import contentDisposition from 'content-disposition'
import FileSaver from 'file-saver'
import _ from 'lodash'
import { AxiosRequestConfig } from 'axios'
import axios from '~plugins/axios'

// downloads file from base url (not API) with authorization
export default class FileDownloader {
  static async download(url: string, payload: Record<string, unknown>): Promise<void> {
    const requestParams = {
      baseURL: '',
      method: payload ? 'post' : 'get',
      url,
      responseType: 'blob',
    }

    if (payload) {
      _.merge(requestParams, { data: payload })
    }

    const response = await axios(requestParams as AxiosRequestConfig)

    // for supported browsers, see: https://github.com/eligrey/FileSaver.js
    FileSaver.saveAs(new Blob([response.data]), FileDownloader.filenameFromResponse(response))
  }

  static filenameFromResponse(response: any): string {
    return _.get(
      contentDisposition.parse(response.headers['content-disposition']),
      'parameters.filename',
    )
  }
}
